import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"cross\"><path fill=\"none\" d=\"M0 0h400v400H0z\" data-name=\"Layer 1\" /><g data-name=\"Layer 2\" fill=\"none\" stroke=\"#3c4859\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"13\"><path d=\"M110.58 289.42l178.84-178.84M289.42 289.42L110.58 110.58\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol